const evidenceSourceDropdownList = [
  'ALL',
    //'CLINICALTRIALS',
    'CLINGEN',
    'CLINVAR',
    'CURATED',
    'GWASCAT',
    'HPO',
    'INFERRED',
    'MGD_HUMAN',
    'MGD_MOUSE',
    'MODELS',
    'ORPHANET',
    'PHEWASCAT',
    'PSYGENET',
    'RGD_HUMAN',
    'RGD_RAT',
    'TEXTMINING_HUMAN',
    'UNIPROT',
];

const riskAlleleList = ['A', 'T', 'G', 'C'];

const evidenceLevelDropdownList = ['None', 'Definitive', 'Strong', 'Moderate', 'Disputed', 'Limited'];

const geneTypeDropdownList = [
  'protein-coding',
  'ncRNA',
  'pseudo',
  'other',
  'biological-region',
  'snoRNA',
  'tRNA',
  'snRNA',
  'rRNA',
  'scRNA',
];

const proteinDropdownList = [
  'Calcium-binding protein',
  'Cell adhesion',
  'Cell-cell junction',
  'Cellular structure',
  'Chaperone',
  'Enzyme',
  'Enzyme modulator',
  'Epigenetic regulator',
  'Extracellular structure',
  'G-protein coupled receptor',
  'Immune response',
  'Ion channel',
  'Kinase',
  'Nuclear receptor',
  'Nucleic acid binding',
  'Receptor',
  'Signaling',
  'Storage',
  'Surfactant',
  'Transcription factor',
  'Transporter',
];

const associationTypeDropdownList = [
  'AlteredExpression',
  'Biomarker',
  'CausalMutation',
  'CausalOrContributing',
  'CellMarker', //
  'ChromosomalRearrangement',
  'DrugResponse',
  'EpigenomicAlterations', //
  'FusionGene',
  'GeneticVariation',
  'GermlineCausalMutation',
  'GermlineModifyingMutation',
  'Phosphorylation', //
  'PostTranslationalModification',
  'Protective',
  'SomaticCausalMutation',
  'SusceptibilityMutation',
  'VUS',
];

const consequenceDropdownList = [
  'intron_variant',
  'intergenic_variant',
  'regulatory_region_variant',
  'stop_gained',
  'missense_variant',
  'non_coding_transcript_exon_variant',
  'synonymous_variant',
  '5_prime_UTR_variant',
  'splice_donor_variant',
  '3_prime_UTR_variant',
  'mature_miRNA_variant',
  'frameshift_variant',
  'splice_acceptor_variant',
  'TF_binding_site_variant',
  'splice_region_variant',
  'start_lost',
  'stop_lost',
  'inframe_deletion',
  'protein_altering_variant',
  'inframe_insertion',
  'coding_sequence_variant',
  'stop_retained_variant',
  'upstream_gene_variant',
  'downstream_gene_variant',
  'start_retained_variant',
  'transcript_ablation',
];

const semanticTypeDropdownList = [
  'Disease or Syndrome',
  'Finding',
  'Neoplastic Process',
  'Congenital Abnormality',
  'Anatomical Abnormality',
  'Sign or Symptom',
  'Mental or Behavioral Dysfunction',
  'Pathologic Function',
  'Laboratory Procedure',
  'Cell Function',
  'Acquired Abnormality',
  'Injury or Poisoning',
  'Laboratory or Test Result',
  'Cell or Molecular Dysfunction',
  'Mental Process',
  'Clinical Attribute',
  'Organism Attribute',
  'Organ or Tissue Function',
  'Individual Behavior',
  'Experimental Model of Disease',
  'Temporal Concept',
  'Organism Function',
  'Physiologic Function',
];

const diseaseClassDropdownList = [
  'Behavior and Behavior Mechanisms',
  'Cardiovascular Diseases',
  'Chemically-Induced Disorders',
  'Congenital, Hereditary, and Neonatal Diseases and Abnormalities',
  'Digestive System Diseases',
  'Disorders of Environmental Origin',
  'Endocrine System Diseases',
  'Eye Diseases',
  //"Female Urogenital Diseases and Pregnancy Complications",
  'Hemic and Lymphatic Diseases',
  'Immune System Diseases',
  'Infections',
  //"Male Urogenital Diseases",
  'Mental Disorders',
  'Musculoskeletal Diseases',
  'Neoplasms',
  'Nervous System Diseases',
  'Nutritional and Metabolic Diseases',
  'Occupational Diseases',
  'Otorhinolaryngologic Diseases',
  'Pathological Conditions, Signs and Symptoms',
  'Psychological Phenomena',
  'Respiratory Tract Diseases',
  'Skin and Connective Tissue Diseases',
  'Stomatognathic Diseases',
  'Urogenital Diseases',
  'Wounds and Injuries',
];

const diseaseTypeDropdownList = ['phenotype', 'group', 'disease'];

const hpoDropdownList = [
  'Abnormal cellular phenotype',
  'Abnormality of blood and blood-forming tissues',
  'Abnormality of connective tissue',
  'Abnormality of head or neck',
  'Abnormality of limbs',
  'Abnormality of metabolism/homeostasis',
  'Abnormality of prenatal development or birth',
  'Abnormality of the breast',
  'Abnormality of the cardiovascular system',
  'Abnormality of the digestive system',
  'Abnormality of the ear',
  'Abnormality of the endocrine system',
  'Abnormality of the eye',
  'Abnormality of the genitourinary system',
  'Abnormality of the immune system',
  'Abnormality of the integument',
  'Abnormality of the musculature',
  'Abnormality of the nervous system',
  'Abnormality of the respiratory system',
  'Abnormality of the skeletal system',
  'Abnormality of the thoracic cavity',
  'Abnormality of the voice',
  'Constitutional symptom',
  'Growth abnormality',
  'Neoplasm',
];

const doDropdownList = [
  'disease by infectious agent',
  'disease of anatomical entity',
  'disease of cellular proliferation',
  'disease of mental health',
  'disease of metabolism',
  'genetic disease',
  'physical disorder',
  'syndrome',
];

const dbsnpClassDropdownList = ['snv', 'delins', 'del', 'mnv', 'ins'];

const gofLofDropdownList = ['GOF', 'LOF'];

const chemicalEffectDropdownList = ['unrelated', 'therapeutic', 'toxicity'];

export {
  evidenceSourceDropdownList,
  evidenceLevelDropdownList,
  geneTypeDropdownList,
  proteinDropdownList,
  associationTypeDropdownList,
  consequenceDropdownList,
  semanticTypeDropdownList,
  diseaseClassDropdownList,
  diseaseTypeDropdownList,
  hpoDropdownList,
  doDropdownList,
  dbsnpClassDropdownList,
  gofLofDropdownList,
  riskAlleleList,
  chemicalEffectDropdownList,
};
